import React from 'react';
import { LayoutComposer } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './PrivacyPolicyPage.module.css';

const PrivacyPolicyPage = () => {
    const layoutAreas = `
        topbar
        main
        footer
    `;

    return (
        <LayoutComposer areas={layoutAreas} className={css.root}>
            {layoutProps => {
                const { Topbar, Main, Footer } = layoutProps;
                return (
                    <>
                        <Topbar as="header" className={css.topbar}>
                            <TopbarContainer currentPage="PrivacyPolicyPage" />
                        </Topbar>
                        <Main as="main" className={css.main}>
                            <div className={css.content}>
                                <h1 className={css.title}>Política de Privacidad</h1>
                                <div className={css.lastUpdated}>
                                    Última actualización: {new Date().toLocaleDateString('es-ES')}
                                </div>
                                
                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>1. Introducción</h2>
                                    <p className={css.text}>
                                        En BioCerca, tu privacidad es fundamental. Esta política explica cómo recopilamos, 
                                        utilizamos y protegemos tu información personal cuando utilizas nuestra plataforma.
                                    </p>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>2. Información que Recopilamos</h2>
                                    
                                    <h3 className={css.subsectionTitle}>2.1 Información Personal</h3>
                                    <p className={css.text}>
                                        Recopilamos información que nos proporcionas directamente:
                                    </p>
                                    <ul className={css.list}>
                                        <li>Nombre y apellidos</li>
                                        <li>Dirección de correo electrónico</li>
                                        <li>Número de teléfono</li>
                                        <li>Dirección postal</li>
                                        <li>Información de pago (procesada de forma segura)</li>
                                        <li>Foto de perfil</li>
                                    </ul>

                                    <h3 className={css.subsectionTitle}>2.2 Información de Uso</h3>
                                    <p className={css.text}>
                                        Recopilamos automáticamente información sobre cómo utilizas nuestra plataforma:
                                    </p>
                                    <ul className={css.list}>
                                        <li>Dirección IP</li>
                                        <li>Tipo de dispositivo y navegador</li>
                                        <li>Páginas visitadas y tiempo de navegación</li>
                                        <li>Interacciones con la plataforma</li>
                                        <li>Ubicación geográfica aproximada</li>
                                    </ul>

                                    <h3 className={css.subsectionTitle}>2.3 Información de Agricultores</h3>
                                    <p className={css.text}>
                                        Para los agricultores, también recopilamos:
                                    </p>
                                    <ul className={css.list}>
                                        <li>Información sobre la finca o explotación</li>
                                        <li>Tipo de productos cultivados</li>
                                        <li>Métodos de producción (ecológico, convencional, etc.)</li>
                                        <li>Capacidad de producción</li>
                                        <li>Puntos de recogida</li>
                                    </ul>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>3. Finalidad del Tratamiento</h2>
                                    <p className={css.text}>
                                        Utilizamos tu información para:
                                    </p>
                                    <ul className={css.list}>
                                        <li>Gestionar tu cuenta y perfil de usuario</li>
                                        <li>Facilitar las transacciones entre agricultores y consumidores</li>
                                        <li>Mejorar nuestros servicios y experiencia de usuario</li>
                                        <li>Comunicarnos contigo sobre transacciones y novedades</li>
                                        <li>Garantizar la seguridad y prevención de fraudes</li>
                                        <li>Cumplir con obligaciones legales</li>
                                    </ul>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>4. Base Legal del Tratamiento</h2>
                                    <p className={css.text}>
                                        El tratamiento de tus datos se basa en:
                                    </p>
                                    <ul className={css.list}>
                                        <li><strong>Consentimiento:</strong> Cuando te registras en nuestra plataforma</li>
                                        <li><strong>Ejecución contractual:</strong> Para facilitar las transacciones</li>
                                        <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios</li>
                                        <li><strong>Obligación legal:</strong> Para cumplir con la legislación vigente</li>
                                    </ul>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>5. Conservación de Datos</h2>
                                    <p className={css.text}>
                                        Conservamos tu información personal durante el tiempo necesario para:
                                    </p>
                                    <ul className={css.list}>
                                        <li>Proporcionar los servicios solicitados</li>
                                        <li>Cumplir con obligaciones legales y fiscales</li>
                                        <li>Resolver disputas y reclamaciones</li>
                                        <li>Prevenir fraudes y garantizar la seguridad</li>
                                    </ul>
                                    <p className={css.text}>
                                        Una vez eliminada tu cuenta, conservaremos los datos esenciales durante los plazos 
                                        legalmente establecidos.
                                    </p>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>6. Compartición de Datos</h2>
                                    <p className={css.text}>
                                        Compartimos tu información únicamente en los siguientes casos:
                                    </p>
                                    <ul className={css.list}>
                                        <li><strong>Con otros usuarios:</strong> Información pública de tu perfil</li>
                                        <li><strong>Proveedores de servicios:</strong> Pasarelas de pago, servicios de mensajería</li>
                                        <li><strong>Obligación legal:</strong> Cuando así lo exija la ley</li>
                                        <li><strong>Venta del negocio:</strong> En caso de fusión o adquisición</li>
                                    </ul>
                                    <p className={css.text}>
                                        Nunca vendemos tu información personal a terceros para fines comerciales.
                                    </p>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>7. Derechos de los Usuarios</h2>
                                    <p className={css.text}>
                                        Como usuario, tienes derecho a:
                                    </p>
                                    <ul className={css.list}>
                                        <li><strong>Acceder:</strong> Conocer qué datos tenemos sobre ti</li>
                                        <li><strong>Rectificar:</strong> Corregir datos incorrectos</li>
                                        <li><strong>Suprimir:</strong> Solicitar eliminación de tus datos</li>
                                        <li><strong>Limitar:</strong> Restringir el tratamiento de tus datos</li>
                                        <li><strong>Portabilidad:</strong> Solicitar una copia de tus datos</li>
                                        <li><strong>Oposición:</strong> Oponerte al tratamiento de tus datos</li>
                                    </ul>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>8. Medidas de Seguridad</h2>
                                    <p className={css.text}>
                                        Implementamos rigurosas medidas de seguridad para proteger tu información:
                                    </p>
                                    <ul className={css.list}>
                                        <li>Encriptación de datos en tránsito y en reposo</li>
                                        <li>Control de acceso restrictivo</li>
                                        <li>Monitorización constante de sistemas</li>
                                        <li>Actualizaciones regulares de seguridad</li>
                                        <li>Formación del personal en protección de datos</li>
                                    </ul>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>9. Cookies</h2>
                                    <p className={css.text}>
                                        Utilizamos cookies para mejorar tu experiencia. Puedes consultar nuestra 
                                        Política de Cookies para más información.
                                    </p>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>10. Menores de Edad</h2>
                                    <p className={css.text}>
                                        BioCerca está dirigida a mayores de 18 años. No recopilamos intencionadamente 
                                        información de menores. Si detectamos que un menor nos ha proporcionado datos, 
                                        los eliminaremos inmediatamente.
                                    </p>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>11. Cambios en la Política</h2>
                                    <p className={css.text}>
                                        Podemos actualizar esta política de privacidad. Te notificaremos cualquier cambio 
                                        significativo a través de tu correo electrónico o mediante un aviso en la plataforma.
                                    </p>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>12. Contacto</h2>
                                    <p className={css.text}>
                                        Para ejercer tus derechos o cualquier consulta sobre privacidad:
                                    </p>
                                    <p className={css.contact}>
                                        Email: contacto@biocerca.es<br />
                                        Teléfono:  696867268<br />
                                        
                                    </p>
                                </div>
                            </div>
                        </Main>
                        <Footer>
                            <FooterContainer />
                        </Footer>
                    </>
                );
            }}
        </LayoutComposer>
    );
};

export default PrivacyPolicyPage;
